// extracted by mini-css-extract-plugin
export default {"client":"Clients_client__jX6ow"};